module.exports = __webpack_public_path__ + "img/poetix-logo-other-half.0a590492.svg";